import {
  GET_BANNER_MESSAGES,
  GET_BANNER_MESSAGES_SUCCESS,
  GET_BANNER_MESSAGES_ERROR,
  DELETE_BANNER_MESSAGES,
  DELETE_BANNER_MESSAGES_SUCCESS,
  DELETE_BANNER_MESSAGES_ERROR,
  GET_ADMIN_USER_BANNER_MESSAGES,
  GET_ADMIN_USER_BANNER_MESSAGES_ERROR,
  GET_ADMIN_USER_BANNER_MESSAGES_SUCCESS,
  DELETE_ADMIN_USER_BANNER_MESSAGES,
  DELETE_ADMIN_USER_BANNER_MESSAGES_SUCCESS,
  DELETE_ADMIN_USER_BANNER_MESSAGES_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  banner_messages: [],
  admin_user_banner_messages: [],
}

const BannerMessages = (state = initialState, action) => {
  switch (action.type) {
    case GET_BANNER_MESSAGES:
      return {
        ...state,
      }

    case GET_BANNER_MESSAGES_SUCCESS:
      return {
        ...state,
        banner_messages: action.payload,
      }

    case GET_BANNER_MESSAGES_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ADMIN_USER_BANNER_MESSAGES:
      return {
        ...state,
      }

    case GET_ADMIN_USER_BANNER_MESSAGES_SUCCESS:
      return {
        ...state,
        admin_user_banner_messages: action.payload,
      }

    case GET_ADMIN_USER_BANNER_MESSAGES_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_BANNER_MESSAGES:
      return {
        ...state,
        loading: false,
        error: null
      }
    case DELETE_BANNER_MESSAGES_SUCCESS:
      return {
        ...state,
        banner_messages: state.banner_messages.filter(message => message.id.toString() !== action.payload.id.toString()),
        loading: false,
        error: null
      }

    case DELETE_BANNER_MESSAGES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case DELETE_ADMIN_USER_BANNER_MESSAGES:
      return {
        ...state,
        loading: false,
        error: null
      }
    case DELETE_ADMIN_USER_BANNER_MESSAGES_SUCCESS:
      return {
        ...state,
        admin_user_banner_messages: state.admin_user_banner_messages.filter(message => message.id.toString() !== action.payload.id.toString()),
        loading: false,
        error: null
      }

    case DELETE_ADMIN_USER_BANNER_MESSAGES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:
      return state
  }
}

export default BannerMessages;
